var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.884,
    height: 7.884,
    viewBox: "0 0 7.884 7.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-down-right",
    "data-name": "Icon feather-arrow-down-right",
    transform: "translate(-8.243 17.959) rotate(-94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49476",
    "data-name": "Path 49476",
    d: "M10.5,10.5l5.266,5.266",
    fill: "none",
    stroke: "#284261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49477",
    "data-name": "Path 49477",
    d: "M15.766,10.5v5.266H10.5",
    fill: "none",
    stroke: "#284261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrows);
export default __webpack_public_path__ + "static/media/uparrows.38df03c8394f4f0b4a9003db947ad855.svg";
export { ForwardRef as ReactComponent };